/**
 * Curated hair color swatches for character creation. `BodyPartModifier.primaryColor`
 * accepts any hex string, but a fixed palette (rather than a free RGB picker) keeps the
 * choice a curated, illustrated-feeling one consistent with Sorrem's other authored content.
 */
export interface HairColorSwatch {
    readonly id: string;
    readonly label: string;
    readonly hex: string;
}

export const HAIR_COLOR_SWATCHES: readonly HairColorSwatch[] = [
    { id: 'black', label: 'Black', hex: '#1b1712' },
    { id: 'dark-brown', label: 'Dark Brown', hex: '#3b2418' },
    { id: 'brown', label: 'Brown', hex: '#5c3a21' },
    { id: 'light-brown', label: 'Light Brown', hex: '#8a5a34' },
    { id: 'blonde', label: 'Blonde', hex: '#d4b06a' },
    { id: 'platinum', label: 'Platinum', hex: '#e8e0d0' },
    { id: 'red', label: 'Red', hex: '#8c3a25' },
    { id: 'auburn', label: 'Auburn', hex: '#6e3220' },
    { id: 'silver', label: 'Silver', hex: '#b6b6b6' },
    { id: 'white', label: 'White', hex: '#f2f2ef' },
    { id: 'steel-blue', label: 'Steel Blue', hex: '#3d5a73' },
    { id: 'deep-blue', label: 'Deep Blue', hex: '#22345c' },
    { id: 'emerald', label: 'Emerald', hex: '#2b5c45' },
    { id: 'violet', label: 'Violet', hex: '#4d3266' },
];

export const DEFAULT_HAIR_COLOR_ID = 'brown';
